import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { useGetLink, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import Hidden from "@insite/mobius/Hidden";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, COMMON, TYPOGRAPHY } from "@tSurya/theme/design";
import useEmblaCarousel from "embla-carousel-react";
import parse from "html-react-parser";
import React, { createRef, FC, useCallback, useEffect, useState } from "react";
import { css, ThemeProps, withTheme } from "styled-components";

interface Memberlist {
    img: string;
    title: string;
    imgLink: LinkFieldValue;
}

interface LinksModel {
    fields: Memberlist;
}

const enum fields {
    departments = "departments",
    heading = "heading",
    img = "img",
    img1 = "img1",
    img2 = "img2",
    img3 = "img3",
    link = "link",
    openInNewWidow = "openInNewWidow",
    description = "description",
    imageAligment = "imageAligment",
    slideIndicator = "slideIndicator",
    image = "image",
    divisions = "divisions",
    buttonLink = "buttonLink",
    mobileButtonLink = "mobileButtonLink",
    headingLink = "headingLink",
    buttonLabel = "buttonLabel",
    img1Link = "img1Link",
    img2Link = "img2Link",
    img3Link = "img3Link",
    buttonBackgroundColor="buttonBackgroundColor",
    buttonTextColor="buttonTextColor",
}

type Props = OwnProps & ThemeProps<BaseTheme> & HasShellContext;
interface OwnProps extends WidgetProps {
    fields: {
        members: any;
        [fields.heading]: string;
        [fields.img]: string;
        [fields.img1]: string;
        [fields.img2]: string;
        [fields.img3]: string;
        [fields.img1Link]: LinkFieldValue;
        [fields.img2Link]: LinkFieldValue;
        [fields.img3Link]: LinkFieldValue;
        [fields.openInNewWidow]: boolean;
        [fields.description]: string;
        [fields.link]: LinkFieldValue;
        [fields.imageAligment]: "row" | "row-reverse";
        [fields.divisions]: LinksModel[];
        [fields.description]: string;
        [fields.buttonLink]: LinkFieldValue;
        [fields.mobileButtonLink]: LinkFieldValue;
        [fields.headingLink]: LinkFieldValue;
        [fields.slideIndicator]: boolean;
        [fields.image]: string;
        [fields.buttonBackgroundColor]:string;
        [fields.buttonTextColor]:string;
        [fields.buttonLabel]: string;
        lowerText: LinkFieldValue;
        path2: LinkFieldValue;
    };
    maxNumberOfColumns: number;
    maintitle: string;
    lowerText: LinkFieldValue;
    path2: LinkFieldValue;
}

export interface SurCollborationStyle {
    containerWrapper?: InjectableCss;
    subContainer?: InjectableCss;
    heading?: InjectableCss;
    subHeading?: InjectableCss;
    description: InjectableCss;
    box?: InjectableCss;
    container?: InjectableCss;
    headingContainer?: InjectableCss;
    mainContainer?: InjectableCss;
    ContentImg?: InjectableCss;
    mobileContentImg?: InjectableCss;
    mobileImg?: InjectableCss;
    imageWrapper?: InjectableCss;
    imageContainer?: InjectableCss;
    viewMore?: InjectableCss;
    image?: InjectableCss;
    twrapper?: InjectableCss;
    parentDiv?: GridContainerProps;
    ImageAndSpecialwrapper?: InjectableCss;
    main?: InjectableCss;
    mainWrapper?: InjectableCss;
    button?: LinkPresentationProps;
    parentContainer?: InjectableCss;
    wrapper?: InjectableCss;
    Box?: InjectableCss;
}

export const surCollborationStyle: SurCollborationStyle = {
    containerWrapper: {
        css: css`
            &:last-child {
                margin-bottom: 100px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        &:last-child {
                            margin-bottom: 50px;
                        }
                    `,
                    css`
                        &:last-child {
                            margin-bottom: 50px;
                        }
                    `,
                    css`
                        &:last-child {
                            margin-bottom: 50px;
                        }
                    `,
                    css`
                        &:last-child {
                            margin-bottom: 50px;
                        }
                    `,
                    null,
                ])}
        `,
    },
    subHeading: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        > p {
                            margin-bottom: 0;
                            margin-top: 12px;
                        }
                    `,
                    css`
                        > p {
                            margin-bottom: 0;
                            margin-top: 12px;
                        }
                    `,
                    css`
                        > p {
                            margin-bottom: 12px;
                            margin-top: 0;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
    description: {
        css: css`
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            color: ${getColor("text.main")};
        `,
    },
    box: {
        css: css`
            display: flex;
            gap: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 15px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    subContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        max-width: 704px;
                        margin: 0 auto;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    heading: {
        css: css`
            margin-top: 50px;
            margin-bottom: 12px;
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            color: ${getColor("text.main")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 0;
                    `,
                    css`
                        margin-top: 0;
                    `,
                    css`
                        margin-top: 0;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    headingContainer: {
        css: css`
            margin-top: 86px;
            margin-bottom: 58px;
        `,
    },
    mainContainer: {
        css: css`
            border: 1px solid blue;
            max-width: 611px;
            margin: 0 auto;
        `,
    },
    mobileContentImg: {
        css: css`
            width: 100%;
            img {
                object-fit: cover;
                width: 100%;
                aspect-ratio: 1/1;
                /* max-width: 420px; */
                /* min-width: 420px; */
                /* aspect-ratio: 1/1; */
            }
        `,
    },
    imageContainer: {
        css: css`
            /* border: 1px solid red; */
            display: flex;
            gap: 28px;
        `,
    },
    image: {
        css: css`
            max-width: 216px;
            max-height: 272px;
        `,
    },

    Box: {
        css: css`
            display: flex;
            justify-content: space-between;
        `,
    },
    ContentImg: {
        css: css`
            width: 100%;
            img {
                object-fit: cover;
                width: 100%;
                aspect-ratio: 0.92/1;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        img {
                            object-fit: contain;
                            width: 100%;
                            aspect-ratio: 1/1;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
    mobileImg: {
        css: css`
            img {
                aspect-ratio: 0.8/1;
            }
        `,
    },
    twrapper: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.large};
            line-height: ${TYPOGRAPHY.lineHeight.medium};
            text-align: center;
            color: ${getColor("text.main")};
            text-transform: capitalize;
            margin-top: 15px;
        `,
    },
    parentContainer: {
        css: css`
            position: relative;
            padding: 0;
            width: 100%;
            max-width: 392px;
            flex: 0 0 auto;
            margin-right: 30px;
            margin-left: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        // max-width: 100% !important;
                        margin-right: 18px;
                        margin-left: 10px;
                    `,
                    css`
                        // max-width: 100% !important;
                        margin-right: 18px;
                        margin-left: 10px;
                    `,
                    css`
                        // max-width: 100% !important;
                        margin-right: 20px;
                        margin-left: 10px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    parentDiv: {
        css: css`
            display: flex;
            /* grid-column-gap: 50px; */
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        gap: 0px;
                    `,
                    css`
                        gap: 0px;
                    `,

                    null,
                    null,
                    null,
                ])}
        `,
    },
    container: {
        css: css`
            overflow: hidden;
            width: 100%;
            /* width:calc(100% - 160px); */
            /* max-width: 1280px !important; */
        `,
    },
    wrapper: {
        css: css`
            position: relative;
            max-width: 100%;
            margin-left: auto;
            margin-right: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 10px 0 10px 20px;
                        margin-left: 0;
                        margin-right: 0;
                    `,
                    css`
                        padding: 10px 0 10px 20px;
                        margin-left: 0;
                        margin-right: 0;
                    `,
                    css`
                        padding: 10px 0 10px 20px;
                        margin-left: 0;
                        margin-right: 0;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    ImageAndSpecialwrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            position: relative;
        `,
    },
    main: {
        css: css`
            position: relative;
            width: 100%;
            max-width: ${COMMON.width.content}px !important;
            margin: 0 auto;
        `,
    },
    mainWrapper: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 20px 20px 10px;
                    `,
                    css`
                        padding: 20px;
                    `,
                    css`
                        padding: 20px 20px 30px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
};

const styles = surCollborationStyle;

export const SurCollaborationSlides: FC<Props> = ({
    fields,
    maxNumberOfColumns = fields.divisions.length,
    theme,
    shellContext,
}) => {
    const { url } = useGetLink(fields.link);
    const ctaLinks = useGetLink(fields.headingLink);
    const img1Link = useGetLink(fields.img1Link).url;
    const img2Link = useGetLink(fields.img2Link).url;
    const img3Link = useGetLink(fields.img3Link).url;
    const mobileCtaLinks = useGetLinks(fields?.divisions, o => o.fields?.imgLink).links;

    const afterCarousel = createRef<HTMLSpanElement>();

    const [emblaRef, embla] = useEmblaCarousel();

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [windowResizeTime, setWindowResizeTime] = useState(0);
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);

    const setCanScroll = () => {
        if (shellContext.isInShell) {
            return;
        }
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };

    const getSlidesToScroll = useCallback(() => {
        if (typeof window === "undefined") {
            return maxNumberOfColumns;
        }

        let localSlidesToScroll: number;
        if (window.innerWidth < theme.breakpoints.values[1]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[2]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[3]) {
            localSlidesToScroll = 2;
        } else {
            localSlidesToScroll = 1;
        }
        return Math.min(localSlidesToScroll, maxNumberOfColumns);
    }, [maxNumberOfColumns]);

    const [slidesToScroll, setSlidesToScroll] = useState(getSlidesToScroll());

    const getDraggable = () => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth < theme.breakpoints.values[1];
    };

    const [draggable, setDraggable] = useState(getDraggable());

    useEffect(() => {
        const newSlidesToScroll = getSlidesToScroll();
        setSlidesToScroll(newSlidesToScroll);

        const newDraggable = getDraggable();
        setDraggable(newDraggable);
    }, [maxNumberOfColumns, windowResizeTime]);

    useEffect(() => {
        if (!embla) {
            return;
        }

        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);

        const onWindowResize = () => {
            setWindowResizeTime(Date.now());
        };

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, [embla]);
    const onWindowResize = () => {
        setWindowResizeTime(Date.now());
    };
    React.useEffect(() => {
        onWindowResize();
    }, []);

    React.useEffect(() => {
        if (!embla || !fields.divisions || fields.divisions.length === 0) {
            return;
        }

        embla.reInit({
            align: "start",
            slidesToScroll,
            // draggable: true,
            // loop: fields.divisions.length > slidesToScroll,
            loop: false,
            containScroll: "keepSnaps",
        });
        setCanScroll();
    }, [embla, slidesToScroll, draggable, fields.divisions]);

    if (!fields.divisions || fields.divisions.length === 0) {
        return null;
    }

    const containerStyles = {
        css: css`
            display: flex;
            max-width: ${COMMON.width.content}px;
            margin: 0 auto;
            padding: 40px 0px;
            gap: 45px;
            flex-direction: ${fields.imageAligment};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        flex-direction: column;
                        gap: 30px;
                    `,
                    css`
                        padding: 40px 20px;
                    `,
                    null,
                ])}
        `,
    };

    const imageWrapper = {
        css: css`
            width: 100%;
            height: 100%;
            flex: 0 0 49%;
            max-width: 462px;
            max-height: 500px;
            margin-left: ${fields.imageAligment === "row" ? "69px" : "69px"};
            margin-right: ${fields.imageAligment === "row-reverse" ? "69px" : "0px"};
            margin-left: ${fields.imageAligment === "row-reverse" ? "0" : "69px"};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 0px;
                        max-width: none;
                        max-height: unset;
                    `,
                    css`
                        margin-left: 0px;
                        max-width: none;
                        max-height: unset;
                    `,
                    css`
                        margin-left: 0px;
                        max-width: none;
                        max-height: unset;
                    `,
                    null,
                    null,
                ])}
        `,
    };

   const viewMore :any= {
        css: css`
            margin-top: 12px;
            background-color: ${fields.buttonBackgroundColor};
            span {
                font-family: "Mulish";
                font-style: normal;
                font-weight: 700;
                font-size: 14px;
                line-height: 22px;
                color:${fields.buttonTextColor};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 10px;
                        padding: 0 20px;
                    `,
                    css`
                        margin-top: 10px;
                        padding: 0 20px;
                    `,
                    css`
                        margin-top: 10px;
                    `,
                    null,
                    null,
                ])}
        `,
    }

    return (
        <>
            <StyledWrapper {...styles.containerWrapper}>
                <Hidden below="md">
                    <StyledWrapper {...containerStyles}>
                        <StyledWrapper {...imageWrapper}>
                            <LazyImage
                                src={fields.img}
                                {...styles.ContentImg}
                                altText={fields.heading || "Collaboration Heading"}
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.subContainer}>
                            <StyledWrapper>
                                <Link href={ctaLinks.url} aria-label={fields.heading || "Title"}>
                                    <StyledWrapper {...styles.heading}>{fields.heading}</StyledWrapper>
                                </Link>
                                <StyledWrapper {...styles.subHeading}>
                                    {parse(fields.description, parserOptions)}
                                </StyledWrapper>
                                <StyledWrapper {...styles.imageContainer}>
                                    {img1Link ? (
                                        <Link href={img1Link} aria-label="Collaboration first image" role="button">
                                            <LazyImage
                                                src={fields.img1}
                                                {...styles.image}
                                                altText="Collaboration first image"
                                            />
                                        </Link>
                                    ) : (
                                        <LazyImage
                                            src={fields.img1}
                                            {...styles.image}
                                            altText="Collaboration first image"
                                        />
                                    )}
                                    {img2Link ? (
                                        <Link href={img2Link} role="button" aria-label="Collaboration second image">
                                            <LazyImage
                                                src={fields.img2}
                                                {...styles.image}
                                                altText="Collaboration second image"
                                            />
                                        </Link>
                                    ) : (
                                        <LazyImage
                                            src={fields.img2}
                                            {...styles.image}
                                            altText="Collaboration second image"
                                        />
                                    )}
                                    {img3Link ? (
                                        <Link href={img3Link} role="button" aria-label="Collaboration third image">
                                            <LazyImage
                                                src={fields.img3}
                                                {...styles.image}
                                                altText="Collaboration third image"
                                            />
                                        </Link>
                                    ) : (
                                        <LazyImage
                                            src={fields.img3}
                                            {...styles.image}
                                            altText="Collaboration third image"
                                        />
                                    )}
                                </StyledWrapper>
                                <Link
                                    href={url}
                                    target={fields.openInNewWidow ? `_blank` : `_self`}
                                    {...viewMore}
                                    role="button"
                                    aria-label="View More"
                                >
                                    View More
                                </Link>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </Hidden>

                <Hidden above="sm">
                    <StyledWrapper
                        css={css`
                            opacity: 1;
                            position: relative;
                            margin: 0 auto;
                            margin-top: 40px;
                            padding-top: 30px;
                            padding-right: 60px;
                            padding-bottom: 43px;
                            padding-left: 60px;
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(theme, [
                                    css`
                                        padding: 0px;
                                        padding-bottom: 20px;
                                        margin-top: 0;
                                    `,
                                    css`
                                        padding: 0px;
                                        padding-bottom: 20px;
                                        margin-top: 0;
                                    `,
                                    css`
                                        padding: 0px;
                                        padding-bottom: 20px;
                                        margin-top: 0;
                                    `,
                                    null,
                                    null,
                                ])}
                        `}
                    >
                        <StyledWrapper {...styles.main}>
                            <StyledWrapper {...styles.mainWrapper}>
                                <Link href={ctaLinks.url} role="button" aria-label="Collaboration heading">
                                    <StyledWrapper {...styles.heading}>{fields.heading}</StyledWrapper>
                                </Link>
                                <StyledWrapper {...imageWrapper}>
                                    <LazyImage
                                        src={fields.img}
                                        {...styles.mobileContentImg}
                                        altText="Collaboration main image"
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.subHeading}>
                                    {parse(fields.description, parserOptions)}
                                </StyledWrapper>
                                <StyledWrapper {...styles.Box}></StyledWrapper>
                            </StyledWrapper>

                            <StyledWrapper {...styles.wrapper}>
                                <StyledWrapper {...styles.container} ref={emblaRef}>
                                    <StyledWrapper {...styles.parentDiv}>
                                        {fields.divisions?.map((division, index) => {
                                            return (
                                                <>
                                                    <StyledWrapper
                                                        {...styles.parentContainer}
                                                        style={{ width: `calc(100% / 1.8)` }}
                                                        key={index}
                                                    >
                                                        <StyledWrapper
                                                            css={css`
                                                                width: 100%;
                                                                height: 100%;
                                                                position: relative;
                                                                display: flex;
                                                                flex-direction: column;
                                                            `}
                                                        >
                                                            <StyledWrapper {...styles.ImageAndSpecialwrapper}>
                                                                {mobileCtaLinks[index].url ? (
                                                                    <Link
                                                                        href={mobileCtaLinks[index].url}
                                                                        role="button"
                                                                        aria-label={`Collaboration link ${mobileCtaLinks[index]}`}
                                                                    >
                                                                        <LazyImage
                                                                            {...styles.mobileImg}
                                                                            src={division.fields.img}
                                                                            altText={
                                                                                division.fields.title ||
                                                                                `Collaboration image ${mobileCtaLinks[index]}`
                                                                            }
                                                                        />
                                                                    </Link>
                                                                ) : (
                                                                    <LazyImage
                                                                        {...styles.mobileImg}
                                                                        src={division.fields.img}
                                                                        altText={
                                                                            division.fields.title ||
                                                                            `Collaboration image ${mobileCtaLinks[index]}`
                                                                        }
                                                                    />
                                                                )}
                                                            </StyledWrapper>
                                                        </StyledWrapper>
                                                    </StyledWrapper>
                                                </>
                                            );
                                        })}
                                    </StyledWrapper>
                                </StyledWrapper>
                            </StyledWrapper>
                            <Link
                                href={url}
                                target={fields.openInNewWidow ? `_blank` : `_self`}
                                {...viewMore}
                                aria-label=" View More"
                            >
                                View More
                            </Link>
                        </StyledWrapper>
                    </StyledWrapper>
                </Hidden>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withIsInShell(withTheme(SurCollaborationSlides)),
    definition: {
        group: "Basic",
        displayName: "SurCollaborationSlides",
        fieldDefinitions: [
            {
                name: fields.heading,
                displayName: "Heading",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                tooltip: "text tip",
                placeholder: "text placeholder",
            },
            {
                fieldType: "General",
                name: fields.headingLink,
                displayName: "Heading Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
            },
            {
                fieldType: "Translatable",
                name: fields.img,
                displayName: "Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.description,
                editorTemplate: "RichTextField",
                displayName: "Decription",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.img1,
                displayName: "Image 1",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.img1Link,
                displayName: "Image 1 Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
            },
            {
                fieldType: "Translatable",
                name: fields.img2,
                displayName: "Image 2",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.img2Link,
                displayName: "Image 2 Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
            },
            {
                fieldType: "Translatable",
                name: fields.img3,
                displayName: "Image 3",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.img3Link,
                displayName: "Image 3 Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
            },
            {
                name: fields.imageAligment,
                fieldType: "General",
                displayName: "Image Aligment",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Left", value: "row" },
                    { displayName: "Right", value: "row-reverse" },
                ],
                defaultValue: "Left",
            },
            {
                fieldType: "General",
                name: fields.buttonLabel,
                displayName: "Button Label",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.buttonBackgroundColor,
                displayName: "Button Background Color",
                editorTemplate: "ColorPickerField",
                defaultValue: ``,
            },
            {
                fieldType: "General",
                name: fields.buttonTextColor,
                displayName: "Button Text Color",
                editorTemplate: "ColorPickerField",
                defaultValue: `#866a5b`,
            },
            {
                name: fields.link,
                displayName: "Button Link",
                fieldType: "General",
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
            },
            {
                name: fields.openInNewWidow,
                fieldType: "General",
                editorTemplate: "CheckboxField",
                defaultValue: false,
            },
            {
                name: fields.divisions,
                editorTemplate: "ListField",
                displayName: "Mobile View",
                getDisplay: ({ fields: { title } }) => title || "title",
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "img",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                        displayName: "Image",
                    },
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "imgLink",
                        displayName: "Image Link",
                        editorTemplate: "LinkField",
                        defaultValue: { value: "", type: "Url" },
                    },
                ],
            },
        ],
    },
};
export default widgetModule;
